import airtableProvider from "../../providers/prod/airtable";
import {
	AddOn,
	AddOnPermissionType,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	Price,
} from "../../../../index";

const a003AddOn = new AddOn({
  internalId: "a003",
  externalId: "pro_01h7dv58wf6kxzhwfmdj8w6f4s",
  shortName: "Airtable running total",
  longName: "Airtable running total",
  shortDescription: "Calculate running totals in Airtable",
  longDescription:
    "* Calculate running totals on large tables without reaching the Airtable API limitations.\n* Use advanced features in the calculation, such as grouping the running total, and customizing the running total with various formulas.\n* Running totals are calculated locally on your device and not on our servers, to ensure your data is kept private.",
  type: AddOnType.APP_EXTENSION,
  iconAsset: Asset.image(
    "https://storage.googleapis.com/cdn.version2.io/add-ons/a003/icons/a003_icon_rounded.png"
  ),
  coverAsset: Asset.image(
    "https://storage.googleapis.com/cdn.version2.io/add-ons/a003/assets/background3.png"
  ),
  previewAssets: [
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a003/screenshots/a003_screenshot_1.png"
    ),
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a003/screenshots/a003_screenshot_2.png"
    ),
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a003/screenshots/a003_screenshot_3.png"
    ),
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a003/screenshots/a003_screenshot_4.png"
    ),
  ],
  docsUrl: "https://docs.version2.io/bTp5JWktxZeauJcNA",
  providersIds: [airtableProvider._.id],
  status: AddOnStatus.ACTIVE,
  plans: [
    new AddOnPlan({
      billingCycle: BillingCycle.yearly(),
      internalId: "a003_p001",
      externalId: "pri_01h7dv6c5r50ps0ajadwnz81h5",
      prices: [new Price({ currency: Currency.USD, amount: 0 })],
    }),
    new AddOnPlan({
      billingCycle: BillingCycle.monthly(),
      internalId: "a003_p002",
      externalId: "pri_01h7dv5p9xmqy5qq5ef3470cgp",
      prices: [new Price({ currency: Currency.USD, amount: 0 })],
    }),
  ],
  settingsConfig: [],
  allowedPermissionTypes: [
    AddOnPermissionType.AIRTABLE_ACCOUNT,
		AddOnPermissionType.AIRTABLE_ACCOUNT_INVITE,
    AddOnPermissionType.AIRTABLE_BASE,
		AddOnPermissionType.AIRTABLE_SHARED,
  ],
});

export default a003AddOn;
